import React from 'react';
import PropTypes from 'prop-types';

const Inner = ({ variant, children }) => {
  return <div className={variant || 'auto'}>{children}</div>;
};

Inner.propTypes = {
  variant: PropTypes.string,
  children: PropTypes.node,
};

export default Inner;


// WEBPACK FOOTER //
// ./src/components/Inner.js